import { render, staticRenderFns } from "./scene22.vue?vue&type=template&id=5018dba2&scoped=true&"
import script from "./scene22.vue?vue&type=script&lang=ts&"
export * from "./scene22.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5018dba2",
  null
  
)

export default component.exports